// Per-dog trainer / facility contact cards (multiple). Replaces the previous
// singular TrainerCard.
import ContactCardsSection from "@/components/app/ContactCardsSection";
import { UserRound } from "lucide-react";

const FIELDS = [
  { key: "name",            label: "Name",            placeholder: "e.g. Emma Ryan",         maxLength: 80 },
  { key: "role",            label: "Role / focus",    placeholder: "Obedience · Agility · Rehab vet" },
  { key: "business",        label: "Business / facility", placeholder: "K9 Central" },
  { key: "phone",           label: "Phone",           placeholder: "555-1234" },
  { key: "email",           label: "Email",           placeholder: "emma@k9central.com", type: "email" },
  { key: "class_schedule",  label: "Class schedule",  placeholder: "Tue 6pm · Sat 10am", wide: true },
  { key: "notes",           label: "Notes",           placeholder: "Methods, style, anything worth remembering…", type: "textarea", wide: true },
];

export default function TrainersCard({ dogId }) {
  return (
    <ContactCardsSection
      dogId={dogId}
      path="trainers"
      singular="trainer"
      plural="trainers / facilities"
      Icon={UserRound}
      overline="Care team"
      title="Trainers & facilities"
      intro="Every pro who works with your dog — obedience trainer, agility coach, rehab vet, board-and-train facility."
      fields={FIELDS}
      testidPrefix="trainer"
    />
  );
}
